import PropTypes from 'prop-types';
import './styles.css';

const PageIntro = ({ description, eyebrow, className = '' }) => (
  <div className={`nf-page-intro ${className}`.trim()}>
    {eyebrow && <span className="nf-page-intro__eyebrow">{eyebrow}</span>}
    <p>{description}</p>
  </div>
);

PageIntro.propTypes = {
  description: PropTypes.string.isRequired,
  eyebrow: PropTypes.string,
  className: PropTypes.string,
};

export default PageIntro;